import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "./input";

/**
 * Password input with an inline show/hide toggle.
 *
 * Drop-in replacement for `<Input type="password" ... />` — accepts every prop
 * Input accepts (id, value, onChange, required, className, data-testid, etc.)
 * and forwards the ref to the underlying input element.
 */
const PasswordInput = forwardRef(function PasswordInput(
  { className = "", "data-testid": testId, ...props },
  ref
) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input
        ref={ref}
        {...props}
        type={visible ? "text" : "password"}
        className={`${className} pr-11`}
        data-testid={testId}
        autoComplete={props.autoComplete || "current-password"}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        className="absolute inset-y-0 right-0 px-3 flex items-center text-zinc-400 hover:text-zinc-900 transition-colors"
        aria-label={visible ? "Hide password" : "Show password"}
        tabIndex={-1}
        data-testid={testId ? `${testId}-toggle` : undefined}
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
});

export default PasswordInput;
export { PasswordInput };
